import { RouteConfig } from 'vue-router';
import Administration from './AdministrationPage.vue';
import NavigationAdmin from './components/NavigationAdmin.vue';
import Devices from './components/Devices.vue';
import Indicators from './components/Indicators.vue';
import Users from './components/Users.vue';

const routes: Array<RouteConfig> = [
    {
        path: '/administration',
        name: 'Administration',
        component: Administration,
        children: [
            {
                path: 'devices',
                component: Devices,
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true,
                },
            },
            {
                path: 'indicators',
                component: Indicators,
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true,
                },
            },
            {
                path: 'users',
                component: Users,
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true,
                },
            },
            {
                path: '',
                component: NavigationAdmin,
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true,
                },
            },
        ]
    },
];

export default routes;